import { NextUIProvider } from '@nextui-org/react'
import { I18nextProvider } from 'react-i18next'

import { CardMessageProvider } from '@/Providers/CardMessageProvider'
import { ToastMessageProvider } from '@/Providers/ToastMessageProvider'
import { ProviderLoaderProvider } from '@/Providers/useProviderLoader'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import i18n from '@/configs/i18n'
import { LoadingProvider } from '@/context/LoadingContext'
import { ToastProvider } from '@/context/ToastContext'

export function Providers({
    children
}: {
    children: React.ReactNode
}): JSX.Element {
    return (
        <ErrorBoundary>
            <I18nextProvider i18n={i18n}>
                <NextUIProvider>
                    <CardMessageProvider>
                        <LoadingProvider>
                            <ToastProvider>
                                <ToastMessageProvider>
                                    <ProviderLoaderProvider>
                                        {children}
                                    </ProviderLoaderProvider>
                                </ToastMessageProvider>
                            </ToastProvider>
                        </LoadingProvider>
                    </CardMessageProvider>
                </NextUIProvider>
            </I18nextProvider>
        </ErrorBoundary>
    )
}
